<script>
import {defineComponent} from 'vue'
import {Link} from "@inertiajs/inertia-vue3";

export default defineComponent({
    name: "Pagination",
    props: {
        links: Array,
        preserveQuery: {
            type: Boolean,
            default: false
        },
        queryParams: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        Link,
    },
    methods: {
        getPreservedUrl(url) {
            if (!url || !this.preserveQuery) return url;

            const urlObj = new URL(url);

            // Thêm các tham số query từ props
            Object.entries(this.queryParams).forEach(([key, value]) => {
                if (value !== null && value !== undefined) {
                    urlObj.searchParams.set(key, value);
                }
            });

            return urlObj.href;
        }
    }
})
</script>

<template>
    <div v-if="links.length > 3" class="d-flex justify-content-center">
        <div className="d-flex flex-wrap -mb-1">
            <template v-for="(link, key) in links">
                <div
                    v-if="link.url === null"
                    :key="key"
                    class="mb-1 me-1 px-3 py-2 text-gray-400 text-sm leading-4 border rounded"
                    v-html="link.label"
                />
                <Link
                    v-else
                    :key="`link-${key}`"
                    class="mb-1 me-1 px-3 py-2 text-sm leading-4 hover:bg-white border rounded"
                    :class="{
                        'bg-primary text-white border-primary': link.active,
                        'hover:bg-gray-100 border-gray-300': !link.active
                    }"
                    :href="preserveQuery ? getPreservedUrl(link.url) : link.url"
                    v-html="link.label"
                />
            </template>
        </div>
    </div>
</template>

<style scoped>
.bg-primary {
    background-color: #0d6efd !important;
}
.border-primary {
    border-color: #0d6efd !important;
}
</style>
